import React from 'react';
import Modal from 'antd/lib/modal/Modal';
import { layout, tailLayout, formStyle } from 'containers/common/layout';
import { InputNumber, Select, Divider, Space, Button, Form, Input } from 'antd';

const { TextArea } = Input;
const { Option } = Select;

interface IProps {
    dataId: number,
    editorVisible: boolean,
    editorTitle: string,
    onCancel: any,
}

class MaoliangEdit extends React.Component<IProps> {

    constructor(props: any) {
        super(props);
    }

    state = {}

    cancelModal = () => {
        this.props.onCancel();
    }

    onFinish = () => {

    }

    render() {
        return (
            <Modal
                title="赠送猫粮"
                visible={this.props.editorVisible}
                onCancel={this.cancelModal}
                footer={null}
                maskClosable={false}
                destroyOnClose={true}
            >
                <Form
                    {...layout}
                    initialValues={{
                        ['score']: 1
                    }}
                    onFinish={this.onFinish}
                    size="large"
                    style={formStyle}
                >

                    <Form.Item
                        name="score"
                        label="数量"
                        extra="范围（1-999）"
                        rules={[{ required: true, message: "请填写有效数量" }]}
                    >
                        <InputNumber min={1} max={999} />
                    </Form.Item>
                    <Form.Item
                        name="reason"
                        label="赠送原因"
                        rules={[{ required: true, message: "请选择赠送原因" }]}
                    >
                        <Select>
                            <Option value="1">售后赔偿</Option>
                            <Option value="2">活动赠送</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name="msg"
                        label="发送消息"

                    >
                        <TextArea rows={4}></TextArea>
                    </Form.Item>
                    <Divider />
                    <Form.Item
                        {...tailLayout}
                    >
                        <Space size="large">
                            <Button type="default" onClick={this.cancelModal}>取消</Button>
                            <Button type="primary" htmlType="submit">确认提交</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}

export default MaoliangEdit;